import { useEffect, useState } from "react";
import { History, Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { formatDate } from "@/lib/format";

export function ExpenseHistory({ id }) {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/insaat/expenses/${id}/history`).then(({ data }) => setItems(data.items)).catch((e) => setErr(apiError(e))); }, [id]);
  return (
    <div className="col-span-full border-t border-slate-200 pt-3" data-testid="expense-history">
      <div className="flex items-center gap-1.5 text-[12px] font-semibold text-slate-600 mb-2"><History className="h-3.5 w-3.5" />Değişiklik Geçmişi</div>
      {err ? <div className="text-[12px] text-rose-700">{err}</div> : !items ? <Loader2 className="h-4 w-4 animate-spin text-blue-600" /> : items.length === 0 ? <div className="text-[12px] text-slate-400">Kayıt yok</div> : (
        <ol className="space-y-1.5 max-h-56 overflow-y-auto pr-1">{items.map((h, i) => (
          <li key={i} className="text-[12px] leading-snug" data-testid="expense-history-row">
            <span className="text-slate-400 font-mono">{formatDate(h.at)}</span> · <b>{h.user_name}</b> · {h.label}
            {(h.old != null || h.new != null) && h.action === "update"
              ? <span>: <span className="line-through text-slate-400">{String(h.old ?? "—")}</span> → <span className="text-slate-900">{String(h.new ?? "—")}</span></span>
              : h.new ? <span className="text-slate-500"> – {String(h.new)}</span> : null}
          </li>))}</ol>)}
    </div>
  );
}
